import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93f3d784"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "aria-expanded"]
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "content"
}

import { ref } from "vue";

interface Props {
  /** text to show in title button */
  text: string;
  /** icon to show in title button */
  icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAccordion',
  props: {
    text: null,
    icon: null
  },
  setup(__props: any) {



/** whether accordion is open or not */
const expanded = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "title",
      "aria-label": expanded.value ? 'Collapse section' : 'Expand section',
      "aria-expanded": expanded.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _createElementVNode("span", _hoisted_2, [
        (__props.text)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.text), 1))
          : _createCommentVNode("", true),
        (__props.icon)
          ? (_openBlock(), _createBlock(_component_AppIcon, {
              key: 1,
              class: "icon",
              icon: __props.icon
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_AppIcon, {
        class: "caret",
        icon: "angle-down",
        "data-expanded": expanded.value
      }, null, 8, ["data-expanded"])
    ], 8, _hoisted_1),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})